module.exports = __webpack_public_path__ + "p1_img2.jpg?cdc20293622bc27d13051c0d2a8fba14";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p1/p1_img2.jpg
// module id = 104
// module chunks = 0